// // import ContactSection from "../components/ContactForm";
// // import Header from "../components/Header";
// // import HeroSection from "../components/HeroSection";
// // import HeroSection2 from "../components/HeroSection2";
// // import ServicesSection from "../components/Services";

// // export default function ServicesPage () {
// //    return(
// //     <div className="font-body">
// //     <Header />
// //     <section className="relative py-10 md:py-20 bg-gradient-to-br from-primary-dark to-primary-base">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="text-center">
// //           {/* Decorative elements */}
// //           <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
// //             <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
// //               Services
// //             </span>
// //           </h1>
// //         </div>
// //       </div>
// // </section>
// //     <ServicesSection />
    
// //   </div>
// //    )
  
// // }

// import { PrinterIcon, DocumentTextIcon, GlobeAltIcon, BookOpenIcon, GiftIcon, SparklesIcon } from '@heroicons/react/24/outline'
// import Header from '../components/Header'

// export default function ServicesPage() {
//   const services = [
//     {
//       title: "Offset Printing",
//       icon: <PrinterIcon className="h-12 w-12 text-primary-base" />,
//       description: "High-volume commercial printing with impeccable color accuracy",
//       features: [
//         "Ideal for 500+ quantity orders",
//         "Pantone color matching",
//         "Sheet sizes up to 40\"",
//         "UV and aqueous coating options"
//       ]
//     },
//     {
//       title: "Digital Printing",
//       icon: <DocumentTextIcon className="h-12 w-12 text-primary-base" />,
//       description: "Quick turnaround short-run printing with premium finishes",
//       features: [
//         "1-500 quantity orders",
//         "Same-day printing available",
//         "Personalization capabilities",
//         "Wide format up to 13\" x 19\""
//       ]
//     },
//     {
//       title: "Card Printing",
//       icon: <GlobeAltIcon className="h-12 w-12 text-primary-base" />,
//       description: "Eye-catching displays for indoor and outdoor use",
//       features: [
//         "Up to 10ft wide formats",
//         "UV-resistant inks",
//         "Vinyl, canvas, and mesh materials",
//         "Lamination and mounting options"
//       ]
//     },
//     {
//       title: "Brochure Printing",
//       icon: <BookOpenIcon className="h-12 w-12 text-primary-base" />,
//       description: "Professional finishing services for polished results",
//       features: [
//         "Perfect binding",
//         "Saddle stitching",
//         "Foiling and embossing",
//         "Die-cutting services"
//       ]
//     },
//     {
//       title: "Packaging Solutions",
//       icon: <GiftIcon className="h-12 w-12 text-primary-base" />,
//       description: "Custom packaging that elevates your brand",
//       features: [
//         "Folding cartons",
//         "Rigid box packaging",
//         "Eco-friendly materials",
//         "Hot stamping finishes"
//       ]
//     },
//     {
//       title: "Pre-Press Services",
//       icon: <SparklesIcon className="h-12 w-12 text-primary-base" />,
//       description: "File preparation and color management expertise",
//       features: [
//         "PDF optimization",
//         "Color proofing",
//         "Bleed and trim setup",
//         "Press-ready file preparation"
//       ]
//     }
//   ]

//   return (
//     <div className="bg-neutral-light">
//       <Header />

//       {/* Service Hero */}
//       <section className="relative py-20 bg-primary-dark text-neutral-light">
//         <div className="max-w-7xl mx-auto px-4 text-center">
//           <h1 className="text-4xl md:text-6xl font-heading mb-6">
//             Premium Printing Services
//           </h1>
//           <p className="text-xl max-w-2xl mx-auto opacity-90">
//             Delivering exceptional print solutions through cutting-edge technology 
//             and decades of craftsmanship
//           </p>
//         </div>
//       </section>

//       {/* Service Grid */}
//       <section className="py-20 px-4">
//         <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {services.map((service, index) => (
//             <div 
//               key={index}
//               className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 group"
//             >
//               <div className="p-8">
//                 <div className="mb-6">{service.icon}</div>
//                 <h3 className="text-2xl font-heading text-primary-dark mb-4">
//                   {service.title}
//                 </h3>
//                 <p className="text-secondary-base mb-6">{service.description}</p>
//                 <ul className="space-y-3 mb-8">
//                   {service.features.map((feature, fIndex) => (
//                     <li 
//                       key={fIndex}
//                       className="flex items-center text-secondary-base"
//                     >
//                       <svg 
//                         className="h-5 w-5 text-accent-base mr-2 flex-shrink-0" 
//                         fill="none" 
//                         stroke="currentColor" 
//                         viewBox="0 0 24 24"
//                       >
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                       </svg>
//                       {feature}
//                     </li>
//                   ))}
//                 </ul>
//                 <button className="text-accent-base font-semibold hover:text-accent-light flex items-center">
//                   Learn More
//                   <svg 
//                     className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" 
//                     fill="none" 
//                     stroke="currentColor" 
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                   </svg>
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Technical Specifications */}
//       <section className="py-20 bg-primary-base/10">
//         <div className="max-w-7xl mx-auto px-4">
//           <div className="text-center mb-16">
//             <h2 className="text-3xl font-heading text-primary-dark mb-4">
//               Technical Capabilities
//             </h2>
//             <p className="text-secondary-base max-w-2xl mx-auto">
//               State-of-the-art equipment and materials for unmatched print quality
//             </p>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8">
//             <div className="bg-white p-8 rounded-xl shadow-md">
//               <h3 className="text-xl font-heading text-primary-dark mb-4">
//                 Offset Printing
//               </h3>
//               <ul className="space-y-3 text-secondary-base">
//                 <li>• Heidelberg Speedmaster XL 106</li>
//                 <li>• 6-color printing with coating</li>
//                 <li>• Sheet size: 29.5" × 41"</li>
//                 <li>• 300-600 lpi resolution</li>
//               </ul>
//             </div>

//             <div className="bg-white p-8 rounded-xl shadow-md">
//               <h3 className="text-xl font-heading text-primary-dark mb-4">
//                 Digital Printing
//               </h3>
//               <ul className="space-y-3 text-secondary-base">
//                 <li>• HP Indigo 12000 Digital Press</li>
//                 <li>• 7-color digital printing</li>
//                 <li>• Up to 13" × 19" sheet size</li>
//                 <li>• 2400 dpi resolution</li>
//               </ul>
//             </div>

//             <div className="bg-white p-8 rounded-xl shadow-md">
//               <h3 className="text-xl font-heading text-primary-dark mb-4">
//                 Finishing
//               </h3>
//               <ul className="space-y-3 text-secondary-base">
//                 <li>• Heidelberg Stahlfolder</li>
//                 <li>• Horizon Perfect Binder</li>
//                 <li>• UV Coating & Lamination</li>
//                 <li>• Die-cutting & Embossing</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 bg-primary-dark text-neutral-light">
//         <div className="max-w-4xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-heading mb-6">
//             Ready to Start Your Project?
//           </h2>
//           <p className="text-lg mb-8 opacity-90">
//             Request a quote or consult with our printing experts
//           </p>
//           <div className="flex justify-center gap-6">
//             <button className="bg-accent-base text-primary-dark px-8 py-3 rounded-full
//               font-semibold hover:bg-accent-light transition-colors shadow-lg">
//               Request Quote
//             </button>
//             <button className="border-2 border-neutral-light/30 px-8 py-3 rounded-full
//               hover:border-accent-base hover:text-accent-base transition-colors">
//               Schedule Consultation
//             </button>
//           </div>
//         </div>
//       </section>
//     </div>
//   )
// }

import { PrinterIcon, DocumentTextIcon, GlobeAltIcon, BookOpenIcon, GiftIcon, SparklesIcon } from '@heroicons/react/24/outline'
import { Link, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ContactSection from '../components/ContactForm'
import { useEffect } from 'react'

export default function ServicesPage() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const services = [
    {
      title: "Offset Printing",
      icon: <PrinterIcon className="h-12 w-12 text-primary-base" />,
      description: "High-volume commercial printing with impeccable color accuracy",
      features: [
        "Ideal for 500+ quantity orders",
        "Pantone color matching",
        "Sheet sizes up to 40\"",
        "UV and aqueous coating options"
      ],
      link: "/services/offset-printing"
    },
    {
      title: "Digital Printing",
      icon: <DocumentTextIcon className="h-12 w-12 text-primary-base" />,
      description: "Quick turnaround short-run printing with premium finishes",
      features: [
        "1-500 quantity orders",
        "Same-day printing available",
        "Personalization capabilities",
        "Wide format up to 13\" x 19\""
      ],
      link: "/services/digital-printing"
    },
    {
      title: "Card Printing",
      icon: <GiftIcon className="h-12 w-12 text-primary-base" />,
      description: "Custom cards for all occasions with high-quality finishes",
      features: [
        "Business cards, greeting cards, and more",
        "Personalization options",
        "Various paper stocks",
        "Embossing, foiling, and UV coating options"
      ],
      link: "/services/card-printing"
    },
    {
      title: "Brochure Printing",
      icon: <DocumentTextIcon className="h-12 w-12 text-primary-base" />,
      description: "Professionally designed brochures to showcase your business",
      features: [
        "Trifold, bifold, and custom folds",
        "High-quality full-color printing",
        "Premium paper options",
        "Glossy, matte, and uncoated finishes"
      ],
      link: "/services/brochure-printing"
    },    
    {
      title: "Packaging Solutions",
      icon: <GiftIcon className="h-12 w-12 text-primary-base" />,
      description: "Custom packaging that elevates your brand",
      features: [
        "Folding cartons",
        "Rigid box packaging",
        "Eco-friendly materials",
        "Hot stamping finishes"
      ],
      link: "/services/packaging"
    },
    {
      title: "Pre-Press Services",
      icon: <SparklesIcon className="h-12 w-12 text-primary-base" />,
      description: "File preparation and color management expertise",
      features: [
        "PDF optimization",
        "Color proofing",
        "Bleed and trim setup",
        "Press-ready file preparation"
      ],
      link: "/services/pre-press"
    }
  ]

  return (
    <div className="bg-neutral-light">
      <Header />

      {/* Service Hero */}
      <section className="relative py-20 bg-primary-dark text-neutral-light">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-heading mb-6">
            Premium Printing Services
          </h1>
          <p className="text-xl max-w-2xl mx-auto opacity-90">
            Delivering exceptional print solutions through cutting-edge technology 
            and decades of craftsmanship
          </p>
        </div>
      </section>

      {/* Service Grid */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <div className="p-8">
                <div className="mb-6">{service.icon}</div>
                <h3 className="text-2xl font-heading text-primary-dark mb-4">
                  {service.title}
                </h3>
                <p className="text-secondary-base mb-6">{service.description}</p>
                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, fIndex) => (
                    <li 
                      key={fIndex}
                      className="flex items-center text-secondary-base"
                    >
                      <svg 
                        className="h-5 w-5 text-accent-base mr-2 flex-shrink-0" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link 
                  to={service.link} 
                  className="text-accent-base font-semibold hover:text-accent-light flex items-center"
                >
                  Learn More
                  <svg 
                    className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-20 bg-primary-dark/10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-heading text-primary-dark mb-4">
              Technical Capabilities
            </h2>
            <p className="text-secondary-base max-w-2xl mx-auto">
              State-of-the-art equipment and materials for unmatched print quality
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md">
              <h3 className="text-xl font-heading text-primary-dark mb-4">
                Offset Printing
              </h3>
              <ul className="space-y-3 text-secondary-base">
                <li>• Heidelberg Speedmaster XL 106</li>
                <li>• 6-color printing with coating</li>
                <li>• Sheet size: 29.5" × 41"</li>
                <li>• 300-600 lpi resolution</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md">
              <h3 className="text-xl font-heading text-primary-dark mb-4">
                Digital Printing
              </h3>
              <ul className="space-y-3 text-secondary-base">
                <li>• HP Indigo 12000 Digital Press</li>
                <li>• 7-color digital printing</li>
                <li>• Up to 13" × 19" sheet size</li>
                <li>• 2400 dpi resolution</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md">
              <h3 className="text-xl font-heading text-primary-dark mb-4">
                Finishing
              </h3>
              <ul className="space-y-3 text-secondary-base">
                <li>• Heidelberg Stahlfolder</li>
                <li>• Horizon Perfect Binder</li>
                <li>• UV Coating & Lamination</li>
                <li>• Die-cutting & Embossing</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="py-20 bg-primary-dark text-neutral-light">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-lg mb-8 opacity-90">
            Request a quote or consult with our printing experts
          </p>
          <div className="flex justify-center gap-6">
            <button className="bg-accent-base text-primary-dark px-8 py-3 rounded-full
              font-semibold hover:bg-accent-light transition-colors shadow-lg">
              Request Quote
            </button>
            <button className="border-2 border-neutral-light/30 px-8 py-3 rounded-full
              hover:border-accent-base hover:text-accent-base transition-colors">
              Schedule Consultation
            </button>
          </div>
        </div>
      </section> */}
      <ContactSection />
      <Footer />
    </div>
  )
}
